import { VStack } from "@chakra-ui/layout";
import { useSearchParams } from "react-router-dom";
import { useState } from "react";
import styled from "styled-components";
import { Back } from "../components/button/Back";
import { CustomersDropDown } from "../components/CustomersDropdown";
import { JobReportRow } from "../components/JobReportRow";
import { LoggedInLayout } from "../components/layouts/LoggedInLayout";
import { PageTitle } from "../components/text/PageTitle";
import { useJobReport, useJobReports } from "@api/hooks";

const ConsultantReportsPage = () => {
	const [selectedJobReport, setSelectedJobReport] = useState("");
	const [selectedCustomer, setSelectedCustomer] = useState("");
	const [searchParams] = useSearchParams();
	const jobId = searchParams.get("id") || "";

	const { jobReports, isLoading } = useJobReports(selectedCustomer, jobId);
	const { jobReport } = useJobReport(selectedJobReport);

	const handleOnClick = (jobReportId: string) => {
		{
			if (selectedJobReport !== jobReportId) {
				setSelectedJobReport(jobReportId);
			} else {
				setSelectedJobReport("");
			}
		}
	};

	return (
		<LoggedInLayout width="s">
			<Styles>
				<VStack spacing={"1.5rem"} align="flex-start">
					<PageTitle loading={isLoading}>Konsultrapporter</PageTitle>

					<Back />

					<CustomersDropDown value={selectedCustomer} onChange={setSelectedCustomer} className={"customer-dropdown"} />

					<VStack alignItems={"stretch"} w="full">
						{jobReports && jobReports.length > 0
							? jobReports.map((item, index: number) => {
									return (
										<JobReportRow
											key={item.id}
											jobReport={item}
											isExpanded={selectedJobReport === item.id}
											onRowClick={() => handleOnClick(item.id)}
											jobReportForm={jobReport?.form}
											index={index}
										/>
									);
								})
							: !isLoading && <p>För närvarande finns det inga konsultrapporter.</p>}
					</VStack>
				</VStack>
			</Styles>
		</LoggedInLayout>
	);
};

export default ConsultantReportsPage;

const Styles = styled.div`
	.customer-dropdown {
		width: 312px;
	}

	.rows {
		width: 100%;
	}

	padding-bottom: 5rem;
`;
